import React, { Component } from 'react';
import PayForTarifBtn from '../PayForTarifBtn';

import s from './style';

import iconError from 'assets/images/icons/icon-error.svg';
import { withTranslation } from 'react-i18next';

class FailPage extends Component {
  render() {
    const { t } = this.props;

    return (
      <div className={s.PayResultWrap}>
        <div className={s.PayResult}>
          <img src={iconError} alt="" className={s.PayResultIcon} />
          <div className={s.PayResultTitle}>
            {t('components.payments.failPage.title')}
          </div>
          <div
            className={s.PayResultText}
            dangerouslySetInnerHTML={{ __html: t('components.payments.failPage.description') }}
          />
          <PayForTarifBtn className={s.PayResultButton}>
            {t('components.payments.failPage.tryMore')}
          </PayForTarifBtn>
        </div>
      </div>
    );
  }
}

export default withTranslation()(FailPage);



// WEBPACK FOOTER //
// ./src/components/Payments/FailPage/FailPage.js